import { RouteName } from '@mews-commander/enums';
import { notEmpty, getUrlParameters } from '@mews-commander/utils';
import { navigateInBaseModal } from '../app/actions/common';
import { TimelineUrlParamsKeys } from './schemas/timelineUrlParamsSchema';

export type GetTimelineUrlParams = Partial<{
    reservationId: string;
    serviceId: string;
    period: string;
    floorNumbers: string[];
    resourceFeatureIds: string[];
    resourceCategoryIds: string[];
    dateTime: string;
    block: string;
}>;

export const EMPTY_FILTER = '';

/**
 * @deprecated use new navigation
 */
export const getTimelineUrl =
    (resolveRoute: $TSFixMe) =>
    ({
        reservationId,
        serviceId,
        period,
        floorNumbers,
        resourceFeatureIds,
        resourceCategoryIds,
        dateTime,
        block,
    }: GetTimelineUrlParams) =>
        resolveRoute(RouteName.ReservationDashboard, {
            query: {
                ...(serviceId ? { [TimelineUrlParamsKeys.ServiceId]: serviceId } : {}),
                ...(period ? { [TimelineUrlParamsKeys.Period]: period } : {}),
                ...(floorNumbers != null
                    ? { [TimelineUrlParamsKeys.FloorNumber]: notEmpty(floorNumbers) ? floorNumbers : EMPTY_FILTER }
                    : {}),
                ...(resourceFeatureIds != null
                    ? {
                          [TimelineUrlParamsKeys.ResourceFeatureId]: notEmpty(resourceFeatureIds)
                              ? resourceFeatureIds
                              : EMPTY_FILTER,
                      }
                    : {}),
                ...(resourceCategoryIds != null
                    ? {
                          [TimelineUrlParamsKeys.ResourceCategoryId]: notEmpty(resourceCategoryIds)
                              ? resourceCategoryIds
                              : EMPTY_FILTER,
                      }
                    : {}),
                ...(dateTime ? { [TimelineUrlParamsKeys.DateTime]: dateTime } : {}),
                ...(reservationId ? { [TimelineUrlParamsKeys.Reservation]: reservationId } : {}),
                ...(block ? { [TimelineUrlParamsKeys.Block]: block } : {}),
            },
        });

/**
 * @deprecated use new navigation
 */
export const showTimeline =
    ({ reservationId = null, serviceId }: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { resolveRoute }: $TSFixMe) => {
        const url = getTimelineUrl(resolveRoute)({ reservationId, serviceId });
        dispatch(navigateInBaseModal(url));
    };

/**
 *
 * @deprecated use Route.useSearch()
 */
export const getTimelineUrlParams = (): GetTimelineUrlParams => {
    const {
        [TimelineUrlParamsKeys.Period]: period,
        [TimelineUrlParamsKeys.DateTime]: dateTime,
        [TimelineUrlParamsKeys.ServiceId]: serviceId,
        [TimelineUrlParamsKeys.FloorNumber]: floorNumbers,
        [TimelineUrlParamsKeys.ResourceFeatureId]: resourceFeatureIds,
        [TimelineUrlParamsKeys.ResourceCategoryId]: resourceCategoryIds,
        [TimelineUrlParamsKeys.Reservation]: reservationId,
        [TimelineUrlParamsKeys.Block]: block,
    } = getUrlParameters(new URL(window.location.href));
    return {
        serviceId: serviceId as string,
        period: period as string,
        floorNumbers: floorNumbers as string[],
        resourceCategoryIds: resourceCategoryIds as string[],
        resourceFeatureIds: resourceFeatureIds as string[],
        dateTime: dateTime as string,
        reservationId: reservationId as string,
        block: block as string,
    };
};
